import { render, staticRenderFns } from "./deleteStaffCommunity.vue?vue&type=template&id=59323421&scoped=true"
import script from "./deleteStaffCommunity.vue?vue&type=script&lang=js"
export * from "./deleteStaffCommunity.vue?vue&type=script&lang=js"
import style0 from "./deleteStaffCommunity.vue?vue&type=style&index=0&id=59323421&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59323421",
  null
  
)

export default component.exports